import React, { useState } from 'react';

const rewardsPolicyData = [
  {
    title: '1. About This Feature',
    content: [
      'This feature provides coins based on your eligible recharge spending. It does not involve gaming, luck, spins, or chance-based rewards. All earnings are fixed, transparent, and directly linked to your actual recharge amount.'
    ]
  },
  {
    title: '2. Eligible Transactions',
    content: [
      'Only the following actions contribute to your reward progress:\n\n• Mobile Recharges\n• DTH Recharges\n• Google Play Redeem\n\nAny other service or transaction does not count toward rewards.'
    ]
  },
  {
    title: '3. Duration & Cycle Rules',
    content: [
      'The reward cycle runs for 28 days from the date you accept this policy. Your progress will automatically reset after each cycle. You may participate again in every new cycle.'
    ]
  },
  {
    title: '4. Progress & Rewards',
    content: [
      'Your recharge spending increases progress across the reward system. When you reach a reward milestone, the corresponding coins become eligible to claim. Once claimed, your earned coins are transferred to your RSKPay Coin Wallet. Claimed coins cannot be reversed or cancelled.'
    ]
  },
  {
    title: '5. Coin Usage',
    content: [
      'Earned coins can be used within RSKPay for: Redeeming to your RSKPay Wallet (as allowed) and accessing eligible offers or features within the app. Coins cannot be withdrawn as direct cash, sent or transferred to another user, sold, traded, or used outside RSKPay, or carried over to the next cycle as progress. Your earned coins will always remain in your wallet unless used.'
    ]
  },
  {
    title: '6. Transaction Validity',
    content: [
      'Only genuine, successful, and completed eligible transactions count. The following will not add progress: Failed or reversed recharges, cancelled transactions, fraudulent or suspicious activity.'
    ]
  },
  {
    title: '7. User Consent & Responsibility',
    content: [
      'You must accept this policy to activate and use the reward feature. If you do not accept, the feature remains locked. Providing incorrect information, misuse, or attempting multiple accounts may result in removal from the program.'
    ]
  },
  {
    title: '8. Modifications & Updates',
    content: [
      'RSKPay may update the reward structure, coin usage, or program rules whenever required. Any changes will be displayed within the app.'
    ]
  },
  {
    title: '9. Final Notes',
    content: [
      'This policy ensures transparent, fair, and non-gaming reward distribution. Your participation is voluntary, and by accepting, you agree to all the terms listed.'
    ]
  }
];

function RewardsPolicySection() {
  const [activeSection, setActiveSection] = useState(-1);

  return (
    <section id="rewards-policy" className="rewards-policy">
      <h1>
        <span>RSKPay</span>
        <span className="text-gradient"> Rewards Policy</span>
      </h1>

      <div className="policy-content">
        <div className="policy-accordion">
          {rewardsPolicyData.map((section, index) => (
            <div key={index} className="policy-item">
              <button
                className={`policy-header ${activeSection === index ? 'active' : ''}`}
                onClick={() => setActiveSection(activeSection === index ? -1 : index)}
              >
                {section.title}
                <span className="policy-toggle">{activeSection === index ? '−' : '+'}</span>
              </button>

              {activeSection === index && (
                <div className="policy-body">
                  {section.content.map((paragraph, pIndex) => (
                    <p key={pIndex} className="policy-paragraph">
                      {paragraph.split('\n').map((line, i) => (
                        <span key={i}>
                          {line}
                          <br />
                        </span>
                      ))}
                    </p>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default RewardsPolicySection;
